module.exports = __webpack_public_path__ + "img/svg/upload-success.5be40f5557e3997312a26f33367121ea.svg";